import { h } from "preact";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";


const WhiteTextTypography = withStyles({
  root: {
    color: "#FFFFFF",
  },
})(Typography);

export default WhiteTextTypography;
